import React from 'react';
import ApprovalList from '../ApprovalList';
import IPublishRequestOverview from '@Shared.Angular/@types/core/contracts/queryModel/governance/publishRequestOverview';

interface Props {
  isMobile: boolean;
  filteredItems: IPublishRequestOverview[];
}

const SentForApprovalList: React.FC<Props> = ({ isMobile, filteredItems }) => {
  return (
    <ApprovalList
      isMobile={isMobile}
      filteredItems={filteredItems}
      roleLabel="Category Publisher"
      displayField="approverName"
      emptyStateData={{
        summaryText: 'No pending publish approval requests',
        bodyText: "You haven't submitted any publish requests for approval"
      }}
    />
  );
};

export default SentForApprovalList;
